// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"734e7cae","139":"a2ce45a5","358":"56f4db7a","538":"b22f3526","676":"bfbfc2a8"}[chunkId] + ".chunk.js";
};